<template>
<section
  class="relative h-screen bg-cover bg-center flex flex-col items-center justify-center px-6 space-y-12"
  :style="{ backgroundImage: `url(${require('../assets/dog_bg.jpeg')})` }"
>
  <!-- Filtre noir semi-transparent -->
  <div class="absolute inset-0 bg-black bg-opacity-30 z-10"></div>

  <!-- Texte centré -->
  <div class="relative z-20 max-w-3xl text-center text-white">
    <p class="text-xs md:text-sm uppercase tracking-wide mb-2 text-white">
      Trouvez un vétérinaire près de chez vous
    </p>
    <h1 class="text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug text-white">
      Prenez rendez-vous pour votre animal en quelques clics
    </h1>
  </div>

  <!-- Barre de recherche -->
  <div class="relative z-20 w-full max-w-4xl">
    <SearchBar class="w-full" />
  </div>
</section>

<section class="py-16 bg-gray-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h2 class="text-3xl font-bold text-gray-800 text-center mb-12">Comment ça marche ?</h2>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <!-- Étape 1 -->
      <div class="bg-white shadow-sm border border-slate-200 rounded-lg p-6 flex flex-col items-center text-center">
        <div class="w-16 h-16 flex items-center justify-center rounded-full bg-slate-800 text-white text-xl font-bold mb-4">1</div>
        <h3 class="text-xl font-semibold text-slate-800 mb-2">Recherchez un vétérinaire</h3>
        <p class="text-slate-600">Indiquez votre localisation et trouvez un cabinet vétérinaire proche de chez vous.</p>
      </div>

      <!-- Étape 2 -->
      <div class="bg-white shadow-sm border border-slate-200 rounded-lg p-6 flex flex-col items-center text-center">
        <div class="w-16 h-16 flex items-center justify-center rounded-full bg-slate-800 text-white text-xl font-bold mb-4">2</div>
        <h3 class="text-xl font-semibold text-slate-800 mb-2">Choisissez le type de consultation</h3>
        <p class="text-slate-600">Vaccin, bilan, urgence... sélectionnez les soins adaptés à votre animal.</p>
      </div>

      <!-- Étape 3 -->
      <div class="bg-white shadow-sm border border-slate-200 rounded-lg p-6 flex flex-col items-center text-center">
        <div class="w-16 h-16 flex items-center justify-center rounded-full bg-slate-800 text-white text-xl font-bold mb-4">3</div>
        <h3 class="text-xl font-semibold text-slate-800 mb-2">Réservez en ligne</h3>
        <p class="text-slate-600">Choisissez une date, confirmez votre rendez-vous et recevez un rappel automatique.</p>
      </div>
    </div>
  </div>
</section>




<section class=" py-16 mt-20">
  <div class="max-w-6xl mx-auto px-6 md:px-8 flex flex-col-reverse md:flex-row items-center justify-between gap-10">
    <!-- Texte -->
    <div class="md:w-1/2">
      <h2 class="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
        📱 L'application mobile arrive bientôt !
      </h2>
      <p class="text-gray-600 text-lg mb-6">
        Réservez plus rapidement, recevez des rappels, gérez vos rendez-vous où que vous soyez. Une nouvelle expérience pensée pour vous, directement sur votre smartphone.
      </p>
      <div class="flex gap-4" style="    justify-content: center;">
        <button
          disabled
          class="bg-gray-300 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2 cursor-not-allowed"
        >
          <i class="fab fa-apple text-xl"></i>
          App Store
        </button>
        <button
          disabled
          class="bg-gray-300 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2 cursor-not-allowed"
        >
          <i class="fab fa-google-play text-xl"></i>
          Play Store
        </button>
      </div>
      <p class="text-sm text-gray-400 mt-2 italic">Disponible très bientôt sur iOS & Android.</p>
    </div>

    <!-- Image / Illustration -->
    <div class="md:w-1/2 flex justify-center">
      <img
        src="../assets/iphone.png"
        alt="Mockup application mobile"
        class=""
      />
    </div>
  </div>
</section>


</template>


<script>
import SearchBar from '@/components/SearchBar.vue';

export default {
  name: 'HomePage',
  components: {
    SearchBar
  },
  data() {
    return {
      isMobile: false,
      salons: [
        {
          nom: 'Salon Chic',
          horaire: '09:00 - 18:00',
          distance: '2,5 km',
          image: 'https://storage.googleapis.com/a1aa/image/e9d81b00-62ae-438a-47ca-78fa96db7609.jpg'
        },
        {
          nom: 'Beauté Zen',
          horaire: '10:00 - 20:00',
          distance: '3,1 km',
          image: 'https://storage.googleapis.com/a1aa/image/90ef7f5d-78bb-449b-66fb-c65b090069b5.jpg'
        },
        {
          nom: 'Coiffure Express',
          horaire: '08:00 - 19:00',
          distance: '1,2 km',
          image: 'https://storage.googleapis.com/a1aa/image/6fa9bc89-7fd0-42ee-64f9-08d6e517cb1b.jpg'
        },
        {
          nom: 'L’Atelier du Style',
          horaire: '11:00 - 21:00',
          distance: '4,0 km',
          image: 'https://storage.googleapis.com/a1aa/image/871bded9-8754-4f7f-5db0-3efb1f93ab92.jpg'
        }
      ]
    }
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth < 768;
    }
  }
}
</script>
